import Big from 'big.js';
import { DateTime } from 'luxon';
import axios from 'smg/axios';
import Batch from 'smg/batch';
import * as hyejoo from 'smg/customer-api/hyejoo';
import * as session from 'smg/customer-api/session';
import * as models from 'smg/models';
import * as template from 'smg/template';
import { DollarFormat } from 'smg/util';
import { PageLoader } from '../account';
import { Relref } from '../hugo';
declare interface myWindow extends Window {
    readonly cloudFront: string;
    readonly apiRoot: string;
}
declare const window: myWindow;

export default async function main() {
    if (await session.Redirect(undefined, Relref('/login'))) {
        return;
    }

    const b = new Batch();

    void b.Exec();

    const pl: PageLoader<models.Order> = new PageLoader<models.Order>({
        get: () => axios.get<hyejoo.Orders>('/orders', {
            params: {
                'sort': pl.Sort(),
                'max': pl.CurrentPageSize(),
                'data': 'invoiceNumber,created,orderLineItems,orderProofs,orderShippingOptions,orderPayments,total,paid,balance,totalSansTax,orderStatusID',
                'p': pl.CurrentPage(),
                'q': pl.Search(),
            },
        }).then(resp => ({ rows: resp.data.orders, nextPage: resp.data.nextPage })),
        draw: order => {
            const el = template.Clone('#order-template');

            const orderNumber = el.querySelector('#template-order-number') as HTMLAnchorElement;
            orderNumber.textContent = String(order.invoiceNumber);
            orderNumber.href = `${Relref('/orders')}track/?id=${order.id || ''}`;

            const shippedTo = el.querySelector('#recipients-container') as HTMLElement;
            const shipmentRecipients: string[] = [];
            if (order.orderShippingOptions) {
                for (const shippingOption of order.orderShippingOptions) {
                    if (shippingOption.shippingOption?.fullName) {
                        shipmentRecipients.push(shippingOption.shippingOption.fullName);
                    }
                }
            }
            for (const recipient of shipmentRecipients) {
                const pEl = document.createElement('p');
                pEl.style.marginBottom = '0';
                pEl.textContent = recipient;
                shippedTo.append(pEl);
            }

            const total = el.querySelector('#template-order-total') as HTMLElement;
            total.textContent = DollarFormat(order.total || Big(0));

            const orderStatus = el.querySelector('#template-order-status') as HTMLElement;
            const orderShipments: models.OrderShippingOptionShipment[] = [];
            if (order.orderShippingOptions) {
                for (const shippingOption of order.orderShippingOptions) {
                    if (shippingOption.orderShippingOptionShipments?.length) {
                        for (const shipment of shippingOption.orderShippingOptionShipments) {
                            orderShipments.push(shipment);
                        }
                    }
                }

                let allDelivered = false;
                let hasShipments = false;
                let partiallyDelivered = false;
                let notAllDelivered = false;
                let someDelivered = false;
                for (const shipment of orderShipments) {
                    if (shipment.shipment) {
                        hasShipments = true;
                    }

                    if (!shipment.shipment?.delivered) {
                        notAllDelivered = true;
                    } else {
                        someDelivered = true;
                    }
                }
                if (hasShipments && !notAllDelivered) {
                    allDelivered = true;
                }
                if (hasShipments && !allDelivered && someDelivered) {
                    partiallyDelivered = true;
                }

                switch (true) {
                case allDelivered:
                    orderStatus.textContent = 'Delivered';
                    orderStatus.style.color = 'green';
                    break;
                case partiallyDelivered:
                    orderStatus.textContent = 'Partially Delivered';
                    orderStatus.style.color = 'green';
                    break;
                case hasShipments:
                    orderStatus.textContent = 'Shipped';
                    orderStatus.style.color = 'green';
                    break;
                case order.orderStatusID === models.OrderStatusID.ORDER_STATUSES_CONFIRMED:
                    orderStatus.textContent = 'In Production';
                    orderStatus.style.color = 'rgb(255, 205, 61)';
                    break;
                case order.orderStatusID === models.OrderStatusID.ORDER_STATUSES_UNCONFIRMED:
                    orderStatus.textContent = 'Preparing for Production';
                    orderStatus.style.color = 'rgb(255, 205, 61)';
                    break;
                case order.orderStatusID === models.OrderStatusID.ORDER_STATUSES_ORDER:
                    orderStatus.textContent = 'Order Received';
                    orderStatus.style.color = 'rgb(255, 205, 61)';
                    break;
                }
            }

            const firstChildEl = el.firstElementChild;
            if (firstChildEl) {
                firstChildEl.id = order.id || '';
                firstChildEl.classList.add('bg-target');
                firstChildEl.addEventListener('click', () => {
                    const initSummaryText = document.querySelector('#init-order-summary-text') as HTMLElement;
                    initSummaryText.classList.add('d-none');

                    const orderSummaryInfo = document.querySelector('#order-summary-info') as HTMLElement;
                    orderSummaryInfo.classList.remove('d-none');

                    firstChildEl.firstElementChild?.classList.add('bg-primary', 'bg-opacity-10');
                    const allBgTarget = Array.from(document.querySelectorAll('.bg-target'));
                    for (const bgTarget of allBgTarget) {
                        if (bgTarget.id !== firstChildEl.id) {
                            bgTarget.firstElementChild?.classList.remove('bg-primary', 'bg-opacity-10');
                        }
                    }
                    const latestProofEl = document.querySelector('#latest-order-proof') as HTMLElement;
                    if (!order.orderProofs?.length) {
                        latestProofEl.classList.add('d-none');
                    } else {
                        let latestProof;
                        const sortedProofs = order.orderProofs.reverse();
                        for (const proof of sortedProofs) {
                            latestProof = proof;
                            break;
                        }
                        const latestProofImgEl = document.querySelector('#latest-order-proof-img') as HTMLImageElement;
                        if (latestProof?.proof?.main) {
                            if (latestProof.proof.thumbnail) {
                                latestProofImgEl.src = latestProof.proof.thumbnail;
                            }
                        }
                    }
                    const orderNumber = document.querySelector('#order-number') as HTMLElement;
                    orderNumber.textContent = String(order.invoiceNumber);

                    const orderDate = document.querySelector('#order-date') as HTMLElement;
                    orderDate.textContent = DateTime.fromISO(order.created || '').toLocaleString(DateTime.DATE_SHORT);

                    const orderPreviewStatus = document.querySelector('#order-status') as HTMLElement;
                    orderPreviewStatus.textContent = orderStatus.textContent;

                    const viewDetailsBtn = document.querySelector('#view-details-btn') as HTMLButtonElement;
                    viewDetailsBtn.classList.remove('d-none');
                    viewDetailsBtn.addEventListener('click', () => {
                        window.location.href = `${Relref('/order')}?id=${order.id || ''}`;
                    });
                });
            }

            return el;
        },
    });

    pl.Load();
}